import React from 'react';
import { MedicalProtocolsState, MedicalProtocolsUnloadState } from '../states/MedicalProtocolsState';

// MedicalProtocols Reducer
import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../actions/';

// functions
import * as Functions from '../../functions/common';
import { Protocol } from '../../models/Entities/Protocols/Protocol';
import { ProtocolConsumption } from '../../models/Entities/Protocols/ProtocolConsumption';
import { ProtocolConsumptionTotal } from '../../models/Entities/Protocols/ProtocolConsumptionTotal';
import { ContractStage } from '../../models/Entities/Contracts/ContractStage';
import { ProtocolConsumptionVisit } from '../../models/Entities/Protocols/ProtocolConsumptionVisit';


type KnownAction = 
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Request_Action 
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Receive_Action 
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Fail_Action
| Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_UpdateAll_Fail_Action
| Actions.MedicalProtocols.MedicalProtocols_GetById_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetById_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetById_Fail_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ContractAssociations_Fail_Action
| Actions.Contract.Contract_Associate_To_Protocol_Receive_Action
| Actions.Contract.Contract_Disassociate_From_Protocol_Receive_Action
| Actions.ProtocolPractitioners.ProtocolPractitiones_GetAll_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_ProtocolPatients_Receive_Action
| Actions.ProtocolPractitioners.ProtocolPractitionesStudyTask_GetAll_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_PatientVisit_ByProtocolId_Receive_Action

// visits
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_ByProtocolId_Fail_Action

// visits full
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Request_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Receive_Action
| Actions.MedicalProtocols.MedicalProtocols_GetAll_Visits_Full_ByProtocolId_Fail_Action

// PDF and Excel export actions
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfRequestAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfReceiveAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsPdfFailAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelRequestAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelReceiveAction
| Actions.MedicalProtocols.MedicalProtocolsGetPractitionerVisitsExcelFailAction

// protocol consumption actions
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionCreateRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionCreateSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionCreateFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionUpdateRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionUpdateSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionUpdateFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionDeleteRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionDeleteSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionDeleteFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusFailureAction

// protocol consumption to settle actions
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleFailureAction

// protocol consumption sync process actions
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetAllByProtocolIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetAllByProtocolIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetAllByProtocolIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetByIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetByIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetByIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLastByProtocolIdRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLastByProtocolIdSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessGetLastByProtocolIdFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessCreateRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessCreateSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessCreateFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessUpdateRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessUpdateSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessUpdateFailureAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessDeleteRequestAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessDeleteSuccessAction
| Actions.ProtocolConsumptionSyncProcess.ProtocolConsumptionSyncProcessDeleteFailureAction

// protocols consumption Totals
| Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusFailureAction

// protocol consumption change concept actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptFailureAction

// protocol consumption change producer actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerFailureAction

// protocol consumption change provider actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderFailureAction

// visit link
| Actions.ContractStages.ContractStage_LinkToAProtocolVisit_Request_Action
| Actions.ContractStages.ContractStage_LinkToAProtocolVisit_Receive_Action
| Actions.ContractStages.ContractStage_LinkToAProtocolVisit_Fail_Action

// protocol consumption change amount actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountFailureAction

// protocol consumption change medical service actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceFailureAction

// protocol consumption change visit type actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeFailureAction

// protocol consumption change visit (stage) actions
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitFailureAction
// set as procedure/additional
| Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureFailureAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalRequestAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalSuccessAction
| Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalFailureAction;

 



export const MedicalProtocolsReducer: Reducer<MedicalProtocolsState> = (
    state: MedicalProtocolsState | undefined, incomingAction: Action): MedicalProtocolsState => {
    
    if (state === undefined) {
        return MedicalProtocolsUnloadState as MedicalProtocolsState;
    }

    const action = incomingAction as KnownAction;

    let CurrentProtocol: Protocol | undefined = undefined;

    switch (action.type) {
        case 'MEDICALPROTOCOLS_GET_ALL_REQUEST_ACTION':
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GET_ALL_RECEIVE_ACTION':
            // Merge new protocols with existing ones, preserving additional properties
            const mergedList = action.MedicalProtocols.map((newProtocol: Protocol) => {
                // Find existing protocol with same ID
                const existingProtocol = state.list?.find((p: Protocol) => p.id === newProtocol.id);
                
                if (existingProtocol) {
                    // Merge: keep additional properties from existing, update base properties from new
                    return {
                        ...newProtocol,                          // Base properties from server
                        patients: existingProtocol.patients,     // Preserve loaded patients
                        contractAssociation: existingProtocol.contractAssociation, // Preserve contract association
                        practitioners: existingProtocol.practitioners, // Preserve practitioners
                        practitionersStudyRole: existingProtocol.practitionersStudyRole, // Preserve study role practitioners
                        patientVisits: existingProtocol.patientVisits, // Preserve patient visits
                        consumptions: existingProtocol.consumptions, // Preserve consumptions
                    };
                } else {
                    // New protocol, just add it
                    return newProtocol;
                }
            });
            
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: mergedList.sort(Functions.DynamicSort('title'))
            };
        case 'MEDICALPROTOCOLS_GET_ALL_FAIL_ACTION':
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };
        case 'MEDICALPROTOCOLS_UPDATE_ALL_REQUEST_ACTION':
            return {
                ...state,
                isUpdatingAll: true,
                isUpdatingAllSuccess: undefined,
                FailUpdatingAll: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_UPDATE_ALL_RECEIVE_ACTION':
            // Merge updated protocols with existing ones, preserving additional properties
            const mergedUpdateList = action.MedicalProtocols.map((updatedProtocol: Protocol) => {
                // Find existing protocol with same ID
                const existingProtocol = state.list?.find((p: Protocol) => p.id === updatedProtocol.id);
                
                if (existingProtocol) {
                    // Merge: keep additional properties from existing, update base properties from new
                    return {
                        ...updatedProtocol,                          // Base properties from server
                        patients: existingProtocol.patients,     // Preserve loaded patients
                        contractAssociation: existingProtocol.contractAssociation, // Preserve contract association
                        practitioners: existingProtocol.practitioners, // Preserve practitioners
                        practitionersStudyRole: existingProtocol.practitionersStudyRole, // Preserve study role practitioners
                        patientVisits: existingProtocol.patientVisits, // Preserve patient visits
                        consumptions: existingProtocol.consumptions, // Preserve consumptions
                    };
                } else {
                    // New protocol, just add it
                    return updatedProtocol;
                }
            });
            
            return {
                ...state,
                isUpdatingAll: false,
                isUpdatingAllSuccess: true,
                FailUpdatingAll: false,
                error: undefined,
                list: mergedUpdateList
            };
        case 'MEDICALPROTOCOLS_UPDATE_ALL_FAIL_ACTION':
            return {
                ...state,
                isUpdatingAll: false,
                isUpdatingAllSuccess: false,
                FailUpdatingAll: true,
                error: action.error
            };
        case 'MEDICALPROTOCOLS_GET_BY_ID_REQUEST_ACTION':
            return {
                ...state,
                isLoadingOne: true,
                successLoadingOne: false,
                failOnLoadingOne: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GET_BY_ID_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.MedicalProtocol.id);
            var UpdatedProtocol = action.MedicalProtocol;

            if(CurrentProtocol) {
                UpdatedProtocol = {...UpdatedProtocol, 
                    contractAssociation: CurrentProtocol.contractAssociation, 
                    practitioners: CurrentProtocol.practitioners, 
                    patients: CurrentProtocol.patients, 
                    visits: CurrentProtocol.visits, 
                    patientVisits: CurrentProtocol.patientVisits,
                    ContractVisits: CurrentProtocol.ContractVisits,
                    consumptions: CurrentProtocol.consumptions, 
                    consumptionsSyncProcess: CurrentProtocol.consumptionsSyncProcess, 
                    lastConsumptionSyncProcess: CurrentProtocol.lastConsumptionSyncProcess, 
                    AmountTotals: CurrentProtocol.AmountTotals
                };
            }

            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                error: undefined,
                list: (state.list ? [...state.list?.filter((item: any) => item.id !== UpdatedProtocol.id), UpdatedProtocol]: [UpdatedProtocol])
            };
        case 'MEDICALPROTOCOLS_GET_BY_ID_FAIL_ACTION':
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: action.error
            };
        case 'CONTRACT_ASSOCIATE_TO_PROTOCOL_RECEIVE_ACTION':
            var ProtocolWithContractAssociated = state.list?.find((item: Protocol) => item.id === action.contractProtocolAssociation.protocolId);
            if(ProtocolWithContractAssociated) {
                ProtocolWithContractAssociated = {...ProtocolWithContractAssociated, contractAssociation : action.contractProtocolAssociation};
            }
            return {
                ...state,
                list: (ProtocolWithContractAssociated ? [...state.list?.filter((item: any) => item.id !== action.contractProtocolAssociation.protocolId), ProtocolWithContractAssociated] : state.list).sort(Functions.DynamicSort('title'))
            };
        case 'CONTRACT_DISASSOCIATE_FROM_PROTOCOL_RECEIVE_ACTION':
            var ProtocolWithContractDisassociated = state.list?.find((item: Protocol) => item.id === action.ProtocolId);
            if(ProtocolWithContractDisassociated) {
                ProtocolWithContractDisassociated = {...ProtocolWithContractDisassociated, contractAssociation : undefined};
            }
            return {
                ...state,
                list: (ProtocolWithContractDisassociated ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), ProtocolWithContractDisassociated] : state.list).sort(Functions.DynamicSort('title'))
            };
        case 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_REQUEST_ACTION':
            return {
                ...state,
                isGettingProtocolContractAssociation: true,
                isGettingProtocolContractAssociationSuccess: undefined,
                FailGettingProtocolContractAssociation: false,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_RECEIVE_ACTION':
            const updatedListWithContract = state.list?.map((protocol: Protocol) => {
                if(protocol.id === action.ProtocolId) {
                    // Spread operator preserves all properties including patients
                    return {...protocol, contractAssociation: action.contractAssociation};
                } else {
                    return protocol;
                }
            });
            
            return {
                ...state,
                isGettingProtocolContractAssociation: false,
                isGettingProtocolContractAssociationSuccess: true,
                FailGettingProtocolContractAssociation: false,
                list: updatedListWithContract,
                error: undefined
            };
        case 'MEDICALPROTOCOLS_GETALL_CONTRACTASSOCIATIONS_FAIL_ACTION':
            return {
                ...state,
                isGettingProtocolContractAssociation: false,
                isGettingProtocolContractAssociationSuccess: false,
                FailGettingProtocolContractAssociation: true,
                error: action.error
            };
        case 'PROTOCOL_PRACTITIONERS_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if(protocol.id === action.protocolId) {
                        return {...protocol, practitioners : action.protocolPractitioners};
                    } else {
                        return protocol;
                    }
                })
            };
        case 'PROTOCOL_PRACTITIONERS_STUDYTASK_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if(protocol.id === action.protocolId) {
                        return {...protocol, practitionersStudyTask : action.protocolPractitioners};
                    } else {
                        return protocol;
                    }
                })
            };
        case 'MEDICALPROTOCOLS_GETALL_PROTOCOLPATIENTS_RECEIVE_ACTION':
            // Handle case where list might be undefined
            if (!state.list) {
                return state;
            }
            
            const updatedList = state.list.map((protocol: Protocol) => {
                if(protocol.id === action.ProtocolId) {
                    return {...protocol, patients : action.ProtocolPatients};
                } else {
                    return protocol;
                }
            });
            
            return {
                ...state,
                list: updatedList
            };
        case 'MEDICALPROTOCOLS_GETALL_PATIENTVISIT_BYPROTOCOLID_RECEIVE_ACTION':
            return {
                ...state,
                list: state.list?.map((protocol: Protocol) => {
                    if(protocol.id === action.ProtocolId) {
                        return {...protocol, patientVisits : action.visits};
                    } else {
                        return protocol;
                    }
                })
            };
        case 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_REQUEST_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: true, gettingVisitsSuccess: undefined, failOnGettingVisits: false, ErrorOnGettingVisits: undefined};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            }

        case 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: true, failOnGettingVisits: false, ErrorOnGettingVisits: undefined, visits: action.visits};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        case 'MEDICALPROTOCOLS_GETALL_VISITS_BYPROTOCOLID_FAIL_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: false, failOnGettingVisits: true, ErrorOnGettingVisits: action.error};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        // visit full 
        case 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_REQUEST_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: true, gettingVisitsSuccess: undefined, failOnGettingVisits: false, ErrorOnGettingVisits: undefined};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        case 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: true, failOnGettingVisits: false, ErrorOnGettingVisits: undefined, ContractVisits: action.visits};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };

        case 'MEDICALPROTOCOLS_GETALL_VISITS_FULL_BYPROTOCOLID_FAIL_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.ProtocolId);

            if (CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingVisits: false, gettingVisitsSuccess: false, failOnGettingVisits: true, ErrorOnGettingVisits: action.error};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.ProtocolId), CurrentProtocol] : state.list)
            };
        
        // protocol consumption actions
        case 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingConsumptions: true, gettingConsumptionsSuccess: undefined, failOnGettingConsumptions: false, ErrorOnGettingConsumptions: undefined};
            }

            console.log('CurrentProtocol', CurrentProtocol);

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list),
            };
        case 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if (CurrentProtocol) {
                const hasGroupFilter = !!(action.filters?.GroupId);

                if (hasGroupFilter) {
                    const groupId = action.filters?.GroupId;
                    const updatedConsumptions = (CurrentProtocol.consumptions || []).map((cons: ProtocolConsumption) => {
                        if (cons.groupingId === groupId) {
                            return { ...cons, childConsumption: action.consumptions };
                        }
                        return cons;
                    });

                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: updatedConsumptions,
                        consumptionPagintationState: action.paginationState,
                        consumptionsFilters: action.filters ?? CurrentProtocol.consumptionsFilters,
                        isGettingConsumptions: false,
                        gettingConsumptionsSuccess: true,
                        failOnGettingConsumptions: false,
                        ErrorOnGettingConsumptions: undefined,
                    };
                } else {
                    CurrentProtocol = {
                        ...CurrentProtocol,
                        consumptions: action.consumptions,
                        consumptionPagintationState: action.paginationState,
                        consumptionsFilters: action.filters ?? CurrentProtocol.consumptionsFilters,
                        isGettingConsumptions: false,
                        gettingConsumptionsSuccess: true,
                        failOnGettingConsumptions: false,
                        ErrorOnGettingConsumptions: undefined,
                    };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };
        case 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_FAILURE':
            return {
                ...state,
                isLoadingAllConsumptions: false,
                LoadingAllConsumptionsSuccess: false,
                FailGettingAllConsumptions: true,
                ErrorGettingAllConsumptions: action.error
            };

        case 'PROTOCOLCONSUMPTION_GET_BYID_REQUEST':
            return {
                ...state,
                isLoadingOneConsumption: true,
                LoadingOneConsumptionSuccess: false,
                FailGettingOneConsumption: false,
                ErrorGettingOneConsumption: undefined
            }
        
        case 'PROTOCOLCONSUMPTION_GET_BYID_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), action.consumption]};
            }

            return {
                ...state,
                isLoadingOneConsumption: false,
                LoadingOneConsumptionSuccess: true,
                FailGettingOneConsumption: false,
                ErrorGettingOneConsumption: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GET_BYID_FAILURE':
            return {
                ...state,
                isLoadingOneConsumption: false,
                LoadingOneConsumptionSuccess: false,
                FailGettingOneConsumption: true,
                ErrorGettingOneConsumption: action.error
            };

        
        case 'PROTOCOLCONSUMPTION_CREATE_REQUEST':
            return {
                ...state,
                isCreatingConsumption: true,
                CreatingConsumptionSuccess: false,
                FailCreatingConsumption: false,
                ErrorCreatingConsumption: undefined
            };
        case 'PROTOCOLCONSUMPTION_CREATE_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []), action.consumption]};
            }

            return {
                ...state,
                isCreatingConsumption: false,
                CreatingConsumptionSuccess: true,
                FailCreatingConsumption: false,
                ErrorCreatingConsumption: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };
        
        case 'PROTOCOLCONSUMPTION_CREATE_FAILURE':
            return {
                ...state,
                isCreatingConsumption: false,
                CreatingConsumptionSuccess: false,
                FailCreatingConsumption: true,
                ErrorCreatingConsumption: action.error
            };
        
        case 'PROTOCOLCONSUMPTION_UPDATE_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumption.id);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumption.id), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };
        
        case 'PROTOCOLCONSUMPTION_UPDATE_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.consumption.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdated = action.consumption;

                if(CurrentConsumptionUpdated) {
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated.id), CurrentConsumptionUpdated]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.consumption.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_UPDATE_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };
        
        case 'PROTOCOLCONSUMPTION_DELETE_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isDeleting: true, isDeletedSuccessfully: false, failOnDeleting: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_DELETE_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionDeleted = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumptionDeleted) {
                    
                    CurrentConsumptionDeleted = {...CurrentConsumptionDeleted, isDeleting: false, isDeletedSuccessfully: true, failOnDeleting: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId)]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_DELETE_FAILURE':
                
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionDeletedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumptionDeletedFailure) {
                    
                    CurrentConsumptionDeletedFailure = {...CurrentConsumptionDeletedFailure, isDeleting: false, isDeletedSuccessfully: false, failOnDeleting: true, error: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionDeletedFailure]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_STATUS_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, ischangingStatus: true, statusChanged: false, failonStatusChange: false, ErrorOnStatusChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };
        case 'PROTOCOLCONSUMPTION_CHANGE_STATUS_SUCCESS':
            	
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumptionUpdated: ProtocolConsumption | undefined = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                // udpate consumption status on protocol consumptions
                if(CurrentConsumptionUpdated) {

                    if(action.isForAll) {
                        CurrentProtocol = {...CurrentProtocol, consumptions: CurrentProtocol.consumptions?.map((item: ProtocolConsumption) => {
                            if(item.serviceName === CurrentConsumptionUpdated?.serviceName) {
                                return {...item, status: action.status};
                            } else {
                                return item;
                            }
                        })};
                    } else {
                        CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, status: action.status};
                        CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated?.id), CurrentConsumptionUpdated]};
                    }
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, ischangingStatus: false, statusChanged: true, failonStatusChange: false, ErrorOnStatusChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated?.id), CurrentConsumptionUpdated]};

                    CurrentProtocol = {...CurrentProtocol, consumptionsToSettle: CurrentConsumptionUpdated.status === 6 ? [...(CurrentProtocol.consumptionsToSettle || []), CurrentConsumptionUpdated] : (CurrentProtocol.consumptionsToSettle || []).filter((item: ProtocolConsumption) => item.id !== CurrentConsumptionUpdated?.id)};
                }

                // udpate consumption status on protocol visit consumptions
                if (CurrentProtocol.ConsumptionVisits?.length) {
                    CurrentProtocol = {
                        ...CurrentProtocol,
                        ConsumptionVisits: CurrentProtocol.ConsumptionVisits.map((visit: ProtocolConsumptionVisit) => {
                            if (!visit.consumptions?.some((item: ProtocolConsumption) => item.id === action.consumptionId)) {
                                return visit;
                            }
                            return {
                                ...visit,
                                consumptions: visit.consumptions.map((item: ProtocolConsumption) =>
                                    item.id === action.consumptionId
                                        ? { ...item, status: action.status }
                                        : item
                                ),
                            };
                        }),
                    };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_STATUS_FAILURE':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumptionUpdatedFailure) {
                    
                    CurrentConsumptionUpdatedFailure = {...CurrentConsumptionUpdatedFailure, ischangingStatus: false, statusChanged: false, failonStatusChange: true, ErrorOnStatusChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionUpdatedFailure]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        // protocol consumption sync process actions

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETALL_BYPROTOCOLID_REQUEST':

            return {
                ...state,
                isLoadingAllSyncProcess: true,
                LoadingAllSyncProcessSuccess: false,
                FailGettingAllSyncProcess: false,
                ErrorGettingAllSyncProcess: undefined
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETALL_BYPROTOCOLID_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: action.processes};
            }

            return {
                ...state,
                isLoadingAllSyncProcess: false,
                LoadingAllSyncProcessSuccess: true,
                FailGettingAllSyncProcess: false,
                ErrorGettingAllSyncProcess: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };
        
        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETALL_BYPROTOCOLID_FAILURE':
            
            return {
                ...state,
                isLoadingAllSyncProcess: false,
                LoadingAllSyncProcessSuccess: false,
                FailGettingAllSyncProcess: true,
                ErrorGettingAllSyncProcess: action.error
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GET_BYID_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentProcess = CurrentProtocol.consumptionsSyncProcess?.find((item: any) => item.id === action.syncProcessId);

                if(CurrentProcess) {
                    
                    CurrentProcess = {...CurrentProcess, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []).filter((item: any) => item.id !== action.syncProcessId), CurrentProcess]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GET_BYID_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.process.protocolId);

            if(CurrentProtocol) {

                var CurrentProcessUpdated = action.process;

                if(CurrentProcessUpdated) {
                    
                    CurrentProcessUpdated = {...CurrentProcessUpdated, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []).filter((item: any) => item.id !== CurrentProcessUpdated.id), CurrentProcessUpdated]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.process.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GET_BYID_FAILURE':
        
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentProcessUpdatedFailure = CurrentProtocol.consumptionsSyncProcess?.find((item: any) => item.id === action.syncProcessId);

                if(CurrentProcess) {
                    
                    CurrentProcess = {...CurrentProcess, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []).filter((item: any) => item.id !== action.syncProcessId), CurrentProcess]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLAST_BYPROTOCOLID_REQUEST':
            
            return {
                ...state,
                isLoadingLastSyncProcess: true,
                LoadingLastSyncProcessSuccess: false,
                FailGettingLastSyncProcess: false,
                ErrorGettingLastSyncProcess: undefined
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLAST_BYPROTOCOLID_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, lastConsumptionSyncProcess: action.process};
            }

            return {
                ...state,
                isLoadingLastSyncProcess: false,
                LoadingLastSyncProcessSuccess: true,
                FailGettingLastSyncProcess: false,
                ErrorGettingLastSyncProcess: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_GETLAST_BYPROTOCOLID_FAILURE':
            
            return {
                ...state,
                isLoadingLastSyncProcess: false,
                LoadingLastSyncProcessSuccess: false,
                FailGettingLastSyncProcess: true,
                ErrorGettingLastSyncProcess: action.error
            };  
            
        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_CREATE_REQUEST':
            
            return {
                ...state,
                isCreatingSyncProcess: true,
                CreatingSyncProcessSuccess: false,
                FailCreatingSyncProcess: false,
                ErrorCreatingSyncProcess: undefined
            };
            
        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_CREATE_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.process.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, consumptionsSyncProcess: [...(CurrentProtocol.consumptionsSyncProcess || []), action.process], lastConsumptionSyncProcess: action.process};
            }

            return {
                ...state,
                isCreatingSyncProcess: false,
                CreatingSyncProcessSuccess: true,
                FailCreatingSyncProcess: false,
                ErrorCreatingSyncProcess: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.process.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTIONSYNCPROCESS_CREATE_FAILURE':
            
            return {
                ...state,
                isCreatingSyncProcess: false,
                CreatingSyncProcessSuccess: false,
                FailCreatingSyncProcess: true,
                ErrorCreatingSyncProcess: action.error
            };
        // protocol consumption totals

        case 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST':
            return {
                ...state,
                isLoadingTotals: true,
                LoadingTotalsSuccess: false,	
                FailGettingTotals: false,
                ErrorGettingTotals: undefined
            };
        
        case 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS':


            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, AmountTotals: [...(CurrentProtocol.AmountTotals || []).filter((total: ProtocolConsumptionTotal) =>  total.status != action.status), ...action.total]};
            }

            return {
                ...state,
                isLoadingTotals: false,
                LoadingTotalsSuccess: true,
                FailGettingTotals: false,
                ErrorGettingTotals: undefined,
                list: (CurrentProtocol ? [...state.list?.filter((item: any) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE':
            return {
                ...state,
                isLoadingTotals: false,
                LoadingTotalsSuccess: false,
                FailGettingTotals: true,
                ErrorGettingTotals: action.error
            };

        // protocol consumption change concept actions

        case 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isConcepAssociationChanging: true, conceptAssociationChanged: false, failonConceptAssociationChange: false, ErrorOnConceptAssociationChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumptionUpdated = CurrentProtocol.consumptions?.find((consumption: ProtocolConsumption) => consumption.id === action.consumptionId);

                if(CurrentConsumptionUpdated) {
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, isConcepAssociationChanging: false, conceptAssociationChanged: true, failonConceptAssociationChange: false, ErrorOnConceptAssociationChange: undefined};

                    const updatedConsumptionIds = action.updatedConsumptions.map((item: ProtocolConsumption) => { return item.id } ) ?? [];

                    console.log("total: ", updatedConsumptionIds.length);

                    console.log("ids: ", updatedConsumptionIds);

                    const actuallConsumptions: ProtocolConsumption[] = CurrentProtocol?.consumptions ?? [];

                    console.log("total: ", actuallConsumptions.length);

                    console.log("consumptions: ", actuallConsumptions);

                    const filtredConsumptions: ProtocolConsumption[] = actuallConsumptions.filter((item: ProtocolConsumption) => !updatedConsumptionIds.includes(item.id));

                    console.log("total: ", filtredConsumptions.length);

                    console.log("consumptions: ", filtredConsumptions);

                    const updatedConsumptions: ProtocolConsumption[] = [...filtredConsumptions, ...action.updatedConsumptions]

                    console.log("total: ", updatedConsumptions.length);

                    console.log("consumptions: ", updatedConsumptions);

                    CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isConcepAssociationChanging: false, conceptAssociationChanged: false, failonConceptAssociationChange: true, ErrorOnConceptAssociationChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        // protocol consumption change producer actions

        case 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isProducerChanging: true, producerChanged: false, failonProducerChange: false, ErrorOnProducerChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumptionUpdated = CurrentProtocol.consumptions?.find((consumption: ProtocolConsumption) => consumption.id === action.consumptionId);

                if(CurrentConsumptionUpdated) {
                    
                    CurrentConsumptionUpdated = {...CurrentConsumptionUpdated, isProducerChanging: false, producerChanged: true, failonProducerChange: false, ErrorOnProducerChange: undefined, producer: action.producerId};

                    const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionUpdated];

                    CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumptionUpdatedFailure) {

                    CurrentConsumptionUpdatedFailure = {...CurrentConsumptionUpdatedFailure, isProducerChanging: false, producerChanged: false, failonProducerChange: true, ErrorOnProducerChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumptionUpdatedFailure]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        // protocol consumption change provider actions

        case 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_REQUEST':
            
            var CurrentProtocolProviderRequest = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocolProviderRequest) {

                var CurrentConsumption = CurrentProtocolProviderRequest.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isProviderChanging: true, providerChanged: false, failonProviderChange: false, ErrorOnProviderChange: undefined};

                    CurrentProtocolProviderRequest = {...CurrentProtocolProviderRequest, consumptions: [...(CurrentProtocolProviderRequest.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocolProviderRequest ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocolProviderRequest] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_SUCCESS':
            
            var CurrentProtocolProviderSuccess = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocolProviderSuccess) {

                const updatedConsumptions = [...(CurrentProtocolProviderSuccess.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption?.id), action.consumption];

                CurrentProtocolProviderSuccess = {...CurrentProtocolProviderSuccess, consumptions: updatedConsumptions};
            }

            return {
                ...state,
                list: (CurrentProtocolProviderSuccess ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocolProviderSuccess] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_FAILURE':
            
            var CurrentProtocolProviderFail = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocolProviderFail) {

                var CurrentConsumption = CurrentProtocolProviderFail.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isProviderChanging: false, providerChanged: false, failonProviderChange: true, ErrorOnProviderChange: action.error};
                    
                    console.log("CurrentConsumption: ", CurrentConsumption );
                    
                    let CurrentProtocolConsumption: ProtocolConsumption[] = CurrentProtocolProviderFail.consumptions?.filter((item: ProtocolConsumption) => item.id !== action.consumptionId) || [];

                    CurrentProtocolProviderFail = {...CurrentProtocolProviderFail, consumptions: [...CurrentProtocolConsumption, CurrentConsumption]};
                }

                console.log("CurrentProtocolProviderFail: ", CurrentProtocolProviderFail);
            }

            return {
                ...state,
                list: (CurrentProtocolProviderFail ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocolProviderFail] : state.list)
            };

        // protocol consumption change medical service actions

        case 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isMedicalServiceChanging: true, medicalServiceChanged: false, failonMedicalServiceChange: false, ErrorOnMedicalServiceChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), action.consumption];

                CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isMedicalServiceChanging: false, medicalServiceChanged: false, failonMedicalServiceChange: true, ErrorOnMedicalServiceChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_TYPE_REQUEST':
                
                CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
    
                if(CurrentProtocol) {
    
                    var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);
    
                    if(CurrentConsumption) {
                        
                        CurrentConsumption = {...CurrentConsumption, isVisitTypeChanging: true, visitTypeChanged: false, failonVisitTypeChange: false, ErrorOnVisitTypeChange: undefined};
    
                        CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                    }
                }
    
                return {
                    ...state,
                    list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
                };
        
        case 'PROTOCOLCONSUMPTION_CHANGE_TYPE_SUCCESS':

                    
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                let CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isVisitTypeChanging: false, visitTypeChanged: true, failonVisitTypeChange: false, ErrorOnVisitTypeChange: undefined};

                    const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), action.consumption];

                    CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };
            

        case 'PROTOCOLCONSUMPTION_CHANGE_TYPE_FAILURE':
                                                                
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isVisitTypeChanging: false, visitTypeChanged: false, failonVisitTypeChange: true, ErrorOnVisitTypeChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };                                                      

        // set as procedure
        case 'PROTOCOLCONSUMPTION_SET_PROCEDURE_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumption) {
                    CurrentConsumption = { ...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption] };
                }
            }

            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_PROCEDURE_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                const Updated = { ...action.consumption, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined } as ProtocolConsumption;
                CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions ?? []).filter((c: ProtocolConsumption) => c.id !== Updated.id), Updated] };
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_PROCEDURE_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                var CurrentConsumptionFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumptionFailure) {
                    CurrentConsumptionFailure = { ...CurrentConsumptionFailure, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((c: ProtocolConsumption) => c.id !== action.consumptionId), CurrentConsumptionFailure] };
                }
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        // set as additional
        case 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_REQUEST':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                var CurrentConsumptionAdd = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumptionAdd) {
                    CurrentConsumptionAdd = { ...CurrentConsumptionAdd, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumptionAdd] };
                }
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_SUCCESS':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                const UpdatedAdd = { ...action.consumption, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined } as ProtocolConsumption;
                CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions ?? []).filter((c: ProtocolConsumption) => c.id !== UpdatedAdd.id), UpdatedAdd] };
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        case 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
            if(CurrentProtocol) {
                var CurrentConsumptionAddFailure = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);
                if(CurrentConsumptionAddFailure) {
                    CurrentConsumptionAddFailure = { ...CurrentConsumptionAddFailure, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((c: ProtocolConsumption) => c.id !== action.consumptionId), CurrentConsumptionAddFailure] };
                }
            }
            return { ...state, list: (CurrentProtocol ? [...(state.list ?? []).filter((p: Protocol) => p.id !== action.protocolId), CurrentProtocol] : state.list) };

        // protocol consumption change visit (stage) actions

        case 'PROTOCOLCONSUMPTION_CHANGE_VISIT_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    // Use generic updating flags while stage change is in progress
                    CurrentConsumption = { ...CurrentConsumption, isUpdating: true, isUpdatedSuccessfully: false, failOnUpdating: false, error: undefined };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption] };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_VISIT_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                // identify previous stage before replacing
                let PreviousConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumption.id);
                const previousStageId = PreviousConsumption?.stageId;

                // updated consumption payload (ensure updating flags reset)
                const UpdatedConsumption: ProtocolConsumption = { ...action.consumption, isUpdating: false, isUpdatedSuccessfully: true, failOnUpdating: false, error: undefined } as ProtocolConsumption;

                // replace in flat list
                CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== UpdatedConsumption.id), UpdatedConsumption] };

                // reflect movement across visits if visits are loaded
                if (CurrentProtocol.ConsumptionVisits?.length) {
                    let UpdatedVisits = [...(CurrentProtocol.ConsumptionVisits ?? [])];

                    // remove from any visit that currently contains it and capture removal
                    UpdatedVisits = UpdatedVisits.map((visit: ProtocolConsumptionVisit) => {
                        if (!visit.consumptions?.some((c: ProtocolConsumption) => c.id === UpdatedConsumption.id)) {
                            return visit;
                        }
                        return { ...visit, consumptions: (visit.consumptions || []).filter((c: ProtocolConsumption) => c.id !== UpdatedConsumption.id) };
                    });

                    // add to new visit if present
                    UpdatedVisits = UpdatedVisits.map((visit: ProtocolConsumptionVisit) => {
                        const matchesTarget = visit.contractStageId === UpdatedConsumption.stageId && visit.patientNumberInProtocol === UpdatedConsumption.patientNumberInProtocol;
                        if (!matchesTarget) return visit;
                        return { ...visit, consumptions: [...(visit.consumptions || []).filter((c: ProtocolConsumption) => c.id !== UpdatedConsumption.id), UpdatedConsumption] };
                    });

                    CurrentProtocol = { ...CurrentProtocol, ConsumptionVisits: UpdatedVisits };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_VISIT_FAILURE':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: ProtocolConsumption) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    CurrentConsumption = { ...CurrentConsumption, isUpdating: false, isUpdatedSuccessfully: false, failOnUpdating: true, error: action.error };
                    CurrentProtocol = { ...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: ProtocolConsumption) => item.id !== action.consumptionId), CurrentConsumption] };
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...(state.list ?? []).filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list ?? [])
            };


        case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_REQUEST_ACTION':
        
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId) || undefined;

            if(CurrentProtocol) {

                var CurrentStage = CurrentProtocol?.ContractVisits?.find((stage: ContractStage) => stage.id === action.contractStageId);

                if (CurrentStage) {   
                    
                    CurrentStage = {
                        ...CurrentStage,
                        isLinkingToAProtocolVisit: false,
                        linkedToAProtocolVisitSuccessfully: true, 
                        failOnLinkingToAProtocolVisit: false,
                        errorOnLinkingToAProtocolVisit: undefined
                    };

                    CurrentProtocol.ContractVisits = [...CurrentProtocol?.ContractVisits?.filter((stage: ContractStage) => stage.id !== CurrentStage?.id) ?? [], CurrentStage];
                }
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== CurrentProtocol!.id) ?? [], CurrentProtocol] : state.list
            }
        
        case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_RECEIVE_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentStage = CurrentProtocol?.ContractVisits?.find((stage: ContractStage) => stage.id === action.contractStageId);

                if (CurrentStage) {  
                    
                    CurrentStage = {
                        ...CurrentStage,
                        isLinkingToAProtocolVisit: false,
                        linkedToAProtocolVisitSuccessfully: true, 
                        failOnLinkingToAProtocolVisit: false,
                        errorOnLinkingToAProtocolVisit: undefined,
                        emrProtocolVisitIdRelated: action.protocolVisitId
                    };

                    CurrentProtocol.ContractVisits = [...CurrentProtocol?.ContractVisits?.filter((stage: ContractStage) => stage.id !== CurrentStage?.id) ?? [], CurrentStage];
                }
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== CurrentProtocol!.id) ?? [], CurrentProtocol] : state.list
            }

        case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_FAIL_ACTION':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentStage = CurrentProtocol?.ContractVisits?.find((stage: ContractStage) => stage.id === action.contractStageId);

                if (CurrentStage) {                    
                    
                    CurrentStage = {
                        ...CurrentStage,
                        isLinkingToAProtocolVisit: false,
                        linkedToAProtocolVisitSuccessfully: false, 
                        failOnLinkingToAProtocolVisit: true,
                        errorOnLinkingToAProtocolVisit: action.error
                    };

                    CurrentProtocol.ContractVisits = [...CurrentProtocol?.ContractVisits?.filter((stage: ContractStage) => stage.id !== CurrentStage?.id) ?? [], CurrentStage];
                }
            }

            return {
                ...state,
                list: CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== CurrentProtocol!.id) ?? [], CurrentProtocol] : state.list
            }

            // consumption change amount actions
                
        case 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_REQUEST':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumption = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {
                    
                    CurrentConsumption = {...CurrentConsumption, isAmountChanging: true, amountChanged: false, failonAmountChange: false, ErrorOnAmountChange: undefined};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_SUCCESS':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                const updatedConsumptions = [...(CurrentProtocol.consumptions ?? []).filter((item: ProtocolConsumption) => item.id !== action.consumption.id), action.consumption];

                CurrentProtocol = {...CurrentProtocol, consumptions: updatedConsumptions};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_FAILURE':
            
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {

                var CurrentConsumptionUpdatedFailure = CurrentProtocol.consumptions?.find((item: any) => item.id === action.consumptionId);

                if(CurrentConsumption) {

                    CurrentConsumption = {...CurrentConsumption, isAmountChanging: false, amountChanged: false, failonAmountChange: true, ErrorOnAmountChange: action.error};

                    CurrentProtocol = {...CurrentProtocol, consumptions: [...(CurrentProtocol.consumptions || []).filter((item: any) => item.id !== action.consumptionId), CurrentConsumption]};
                }

            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_REQUEST':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingConsumptionsToSettle: true, gettingConsumptionsToSettleSuccess: false, failOnGettingConsumptionsToSettle: false, ErrorOnGettingConsumptionsToSettle: undefined};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_SUCCESS':

            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);

            if(CurrentProtocol) {
                CurrentProtocol = {...CurrentProtocol, isGettingConsumptionsToSettle: false, gettingConsumptionsToSettleSuccess: true, failOnGettingConsumptionsToSettle: false, ErrorOnGettingConsumptionsToSettle: undefined, consumptionsToSettle: action.consumptions};
            }

            return {
                ...state,
                list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
            };

        case 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_FAILURE':
            CurrentProtocol = state.list?.find((item: Protocol) => item.id === action.protocolId);
                
                if(CurrentProtocol) {
                    CurrentProtocol = {...CurrentProtocol, isGettingConsumptionsToSettle: false, gettingConsumptionsToSettleSuccess: false, failOnGettingConsumptionsToSettle: true, ErrorOnGettingConsumptionsToSettle: action.error};
                }

                return {
                    ...state,
                    list: (CurrentProtocol ? [...state.list?.filter((item: Protocol) => item.id !== action.protocolId), CurrentProtocol] : state.list)
                };
        // PDF Export cases
        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_REQUEST_ACTION':
            return {
                ...state,
                isExportingPdf: true,
                ExportingPdfSuccess: false,
                FailExportingPdf: false,
                ErrorExportingPdf: undefined,
                pdfBlob: undefined
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_RECEIVE_ACTION':
            return {
                ...state,
                isExportingPdf: false,
                ExportingPdfSuccess: true,
                FailExportingPdf: false,
                ErrorExportingPdf: undefined,
                pdfBlob: action.pdfBlob
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_PDF_FAIL_ACTION':
            return {
                ...state,
                isExportingPdf: false,
                ExportingPdfSuccess: false,
                FailExportingPdf: true,
                ErrorExportingPdf: action.error,
                pdfBlob: undefined
            };

        // Excel Export cases
        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_REQUEST_ACTION':
            return {
                ...state,
                isExportingVisitToExcel: true,
                ExportingVisitToExcelSuccess: false,
                FailExportingVisitToExcel: false,
                ErrorExportingVisitToExcel: undefined,
                visitExcelBlob: undefined
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_RECEIVE_ACTION':
            return {
                ...state,
                isExportingVisitToExcel: false,
                ExportingVisitToExcelSuccess: true,
                FailExportingVisitToExcel: false,
                ErrorExportingVisitToExcel: undefined,
                visitExcelBlob: action.excelBlob
            };

        case 'MEDICALPROTOCOLS_GET_PRACTITIONER_VISITS_EXCEL_FAIL_ACTION':
            return {
                ...state,
                isExportingVisitToExcel: false,
                ExportingVisitToExcelSuccess: false,
                FailExportingVisitToExcel: true,
                ErrorExportingVisitToExcel: action.error,
                visitExcelBlob: undefined
            };
        default:
        return state;
    }
};